// Letterheist (pages/Letterheist.jsx) is played on the "letterheist" board.
// Its pieces are lib/lhQueen.js.
export const LH_LAYOUT = "letterheist";
